'use strict';

var React = require("react");
var ReactDom = require("react-dom");
var Root$FormBuilder = require("./Root.bs.js");

((require("./styles/index.css")));

var root = document.querySelector("#root");

if (!(root == null)) {
  ReactDom.render(React.createElement(Root$FormBuilder.make, {}), root);
}

/*  Not a pure module */
